import { isBrowser } from 'acq-utils/lib/misc';

/*
US5635715: reasons and what it does:
(1) We need this to aleviate lagging effect upon vac filter interaction.
    but it can be used for any other situations as well.
(2) The approach is recommended by a wide array of tech sites. Here is one:
    https://stackoverflow.com/questions/3646036/preloading-images-with-javascript
(3) A similar approach is currently used by Consumer site.  
(4) This module also internally tracks what has been processed so to avoid duplicated ops.
*/

const processedUrls = [];

const preloadImages = (imgUrlList = []) => {
  const imgList = typeof imgUrlList === 'string' ? [imgUrlList] : imgUrlList;
  if (!isBrowser() || !Array.isArray(imgList)) {
    return;
  }

  // we use setTimeout to avoid blocking ops from caller
  setTimeout(() => {
    imgList.forEach(url => {
      const urlVal = String(url).trim();
      if (processedUrls.indexOf(urlVal) <= -1) {
        const image = new Image();
        image.src = urlVal;
        processedUrls.push(urlVal);
      }
    });
  }, 50);
};

export default preloadImages;
